import Vue from 'vue'
import Router from 'vue-router'

import LoginForm from '@/components/LoginForm'
import ResetPasswordForm from '@/components/ResetPasswordForm'
import Fcf from '@/components/Fcf'
import FcfList from '@/components/FcfList'
import AdminPage from '@/components/AdminPage'
import NotFoundComponent from '@/components/NotFoundComponent'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: __dirname,
  routes: [
    {
      path: '/login',
      name: 'login',
      component: LoginForm
    },
    {
      path: '/reset-password',
      name: 'reset-password',
      component: ResetPasswordForm
    },
    {
      path: '/',
      name: 'main',
      component: Fcf,
      meta: { auth: true, redirect: '/' }
    },
    {
      path: '/show/:jobNumber',
      name: 'show',
      component: Fcf,
      meta: { auth: true, redirect: '/' }
    },
    {
      path: '/list',
      name: 'list',
      component: FcfList,
      meta: { auth: true, redirect: '/' }
    },
    {
      path: '/list/:status',
      name: 'list_status',
      component: FcfList,
      meta: { auth: true, redirect: '/' }
    },
    {
      path: '/admin',
      name: 'admin',
      component: AdminPage,
      meta: { auth: ['superadmin'], redirect: '/' }
    },
    { path: '*', component: NotFoundComponent }
  ]
})
